import React, { useEffect, useState } from 'react';
import { Spinner } from '../';
import {
  LoadingWrapper,
  Wrapper,
  StyledInsideLoaderWrapper,
  StyledSpinner,
} from './';

export const Loading = ({
  loading = true,
  children,
  fullScreen = false,
  spinnerClassName = '',
  inside,
}) => {
  // const [_loading, setLoading] = useState(loading);
  // useEffect(() => {
  //   if (!loading) setTimeout(() => setLoading(false), 500);
  //   else setLoading(loading);
  // }, [loading]);
  return (
    <>
      {loading ? (
        fullScreen ? (
          <Wrapper>
            <LoadingWrapper>
              <StyledSpinner className="mx-auto w-10_5 h-10_5" type="grow" />
            </LoadingWrapper>
          </Wrapper>
        ) : inside ? (
          <StyledInsideLoaderWrapper>
            <Spinner className={`mx-auto d-block ${spinnerClassName}`} />
          </StyledInsideLoaderWrapper>
        ) : (
          <Spinner className={`mx-auto d-block ${spinnerClassName}`} />
        )
      ) : null}
      {children}
    </>
  );
};
